import React, { useEffect } from "react";
import { IAgreementState } from "../../../../redux/types/IAgreementState";
import { Empty, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";
import { CANCEL_SORTING, NO_DATA, SORT_ASCENDING, SORT_DESCENDING } from "../../../Consts";

interface IDraftAgreementsCommentsReviewProps {
    agreement: IAgreementState;
    draftAgreementMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem;

}

const DraftAgreementsCommentsReview: React.FC<IDraftAgreementsCommentsReviewProps> =  ({
    agreement,
    draftAgreementMaintenanceGeneralDataViewData
}) => {
  const [commentData, setCommentData] = React.useState([]);
  const [viewData, setViewData] = React.useState([])

  useEffect(() => {

    if (agreement?.comments) {


      const dataSource = agreement.comments.map((comment, index) => ({
        key: index,
        category: comment?.commentCategory?.value ? comment.commentCategory.value : "",
        comment: comment?.comment?.value ? comment.comment.value : "",
        descriptions: comment?.comment?.value ? comment.comment.value : "",
        subject: comment?.subject?.value ? comment.subject.value : "",
        date: comment?.date?.value ? comment.date.value : "",
    }));
  
  ;
  setCommentData(dataSource)
  }


  }, [agreement]);

  useEffect(() => {
        if (draftAgreementMaintenanceGeneralDataViewData?.fields) {
            const visibleFields = draftAgreementMaintenanceGeneralDataViewData.fields.filter(field => !field.hidden);
            let newViewData = [];
            visibleFields.forEach(item => {
                newViewData[item.name] = item.data;
            });
            setViewData(newViewData);
        }
    
    }, [agreement, draftAgreementMaintenanceGeneralDataViewData]);

    const columns: ColumnsType<any>  = [
      {
        title: viewData['comment'] || 'Comment',
        dataIndex: 'comment',
        width: 600,
        key: 'comment',
      },
        {
            title: viewData['category'] || 'Category',
            dataIndex: 'category',
            key: 'category',
          },
          {
            title: viewData['date'] || 'Date',
            dataIndex: 'date',
            key: 'date',
          },
          {
            title: viewData['subject'] || 'Subject',
            dataIndex: 'subject',
            key: 'subject',
          },
]


    return <div>
              <div className="headerContainer">
            <div
                className={["headerSection", "activeSection"].join(" ")}
                key={'Comments'}
                data-testid={'Comments' + "-section"}
            >
                {viewData['draftAgreementReviewComments']}
            </div>
        </div>
        <div className='commentTable'>
          <Table 
            dataSource={commentData}
            columns={columns} 
            locale={{
            emptyText: (
                  <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description={viewData[NO_DATA]}
                  />
              ),
              triggerDesc: viewData[SORT_DESCENDING],
              triggerAsc: viewData[SORT_ASCENDING],
              cancelSort: viewData[CANCEL_SORTING],
            }}
          />
        </div>
    </div>
}

export default DraftAgreementsCommentsReview;